import {
  DriverStatus,
  LogbookStatusChange,
  TimelinePeriod,
} from '../../types/logbook';
import { calcNumberOfCols } from './constants';

export const minutesToTimeString = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const remainderMinutes = minutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(remainderMinutes).padStart(
    2,
    '0'
  )}:00`;
};

export const convertToNminTimeline = (
  time: LogbookStatusChange[],
  minInterval: number
): DriverStatus[] => {
  const arr: DriverStatus[] = [];
  for (let i = 0; i < calcNumberOfCols(minInterval); i++) {
    const currentMinutes = i * minInterval;
    const currentTime = minutesToTimeString(currentMinutes);
    const status = time.find(
      ({ changeTime }) => changeTime === currentTime
    )?.status;

    if (status) {
      arr.push(status);
      continue;
    }

    const prevStatus = arr[i - 1];
    if (prevStatus) {
      arr.push(prevStatus);
      continue;
    }

    throw new Error('Invalid time data');
  }
  return arr;
};

export const convertFromNminTimeline = (
  timeline: DriverStatus[],
  minInterval: number
): LogbookStatusChange[] => {
  const arr: LogbookStatusChange[] = [];

  for (let i = 0; i < timeline.length; i++) {
    const lastStatus = arr[arr.length - 1];
    const newStatus = timeline[i];

    if (lastStatus?.status !== newStatus) {
      arr.push({
        status: newStatus,
        changeTime: minutesToTimeString(i * minInterval),
      });
    }
  }

  return arr;
};

export const convertToTimelinePeriods = (
  time: LogbookStatusChange[]
): TimelinePeriod[] => {
  const periods: TimelinePeriod[] = [];

  for (let i = 0; i < time.length; i++) {
    const from = time[i];
    const to = time[i + 1]?.changeTime ?? '24:00:00';

    periods.push({ from: from.changeTime, status: from.status, to });
  }

  return periods;
};
